module.exports = __webpack_public_path__ + "img/gld_gbt846_1985.prt.45ca46e9.jpg";